/**
 * App i18n configuration. Single language for now (Turkish); the structure is
 * built so adding English later means: add 'en' here, add an `en` resource tree,
 * and register the AntD/dayjs locales in `antdLocale.ts` — no call-site changes.
 */
export const SUPPORTED_LANGUAGES = ['tr'] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: AppLanguage = 'tr';
export const FALLBACK_LANGUAGE: AppLanguage = 'tr';

/** Default namespace used when a key is referenced without an explicit `ns:` prefix. */
export const DEFAULT_NS = 'common';

/**
 * Lightweight translator type for non-component helpers (e.g. Zod schema
 * factories). The fully-typed multi-namespace `TFunction` is too heavy to thread
 * through factories (triggers "excessively deep" TS errors), so accept this and
 * cast at the call site: `makeSchema(t as unknown as Translator)`.
 */
export type Translator = (key: string, options?: Record<string, unknown>) => string;
